import React from 'react';
import { Card, Table, Badge, Row, Col, Accordion, Alert } from 'react-bootstrap';
import ClaimerPreviewErrors from './ClaimerPreviewErrors';
import { ClaimerPreviewAgents } from './ClaimerPreviewAgents';
import ClaimerPreviewSubmissionConfig from './ClaimerPreviewSubmissionConfig';
import ClaimerPreviewCompanyInfo from './ClaimerPreviewCompanyInfo';
import ClaimerDataPreviewSeniorOfficer from './ClaimerDataPreviewSeniorOfficer';
import ClaimerDataPreviewProjects from './ClaimerDataPreviewProjects';
import ClaimerPreviewExpenditure from './ClaimerPreviewExpenditure';
import DataPreviewEnchancedSupport from './DataPreviewEnchancedSupport';
export default function DataToSendToClaimer(_ref) {
  let {
    aifReportData
  } = _ref;
  if (!aifReportData) {
    return /*#__PURE__*/React.createElement("div", null, "No data available");
  }
  const {
    submission_configuration,
    aif_model,
    external_id
  } = aifReportData;
  console.log('aifReportData: ', aifReportData);
  const dataIsPresent = !!aif_model && !!submission_configuration;
  return /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center mb-4"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary"
  }, "AIF submission data that would be sent to Claimer")), /*#__PURE__*/React.createElement(ClaimerPreviewErrors, {
    key: Math.random(),
    aifReportData: aifReportData
  }), dataIsPresent && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClaimerPreviewSubmissionConfig, {
    aifReportData: aifReportData
  }), /*#__PURE__*/React.createElement(ClaimerPreviewCompanyInfo, {
    aifReportData: aifReportData
  }), /*#__PURE__*/React.createElement(ClaimerPreviewAgents, {
    aifReportData: aifReportData
  }), /*#__PURE__*/React.createElement(ClaimerDataPreviewSeniorOfficer, {
    aifReportData: aifReportData
  }), /*#__PURE__*/React.createElement(ClaimerDataPreviewProjects, {
    aifReportData: aifReportData
  }), /*#__PURE__*/React.createElement(ClaimerPreviewExpenditure, {
    aifReportData: aifReportData
  }), /*#__PURE__*/React.createElement(DataPreviewEnchancedSupport, {
    aifReportData: aifReportData
  })));
}